
import EditorList from "Editors/EditorList";
import EditorTipTap from "Editors/EditorTipTap";
export default {
  components: {
    EditorList,
    EditorTipTap,
  },
  data() {
    return {
      inView: false,
      startAnimation: false,
      options: [
        {
          name: "title",
          label: "Name",
          type: "text",
        },
        {
          name: "link",
          label: "Link",
          type: "link",
        },
        {
          name: "image",
          label: "Image",
          type: "image",
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.startAnimation = true;
    }, 200);

    let hash = location.hash;
    if (hash) {
      hash = hash.replace("#", "");
      const element = document.getElementById(hash);
      element.scrollIntoView();
    }
  },
};
